import React, { useContext } from "react";
import { classes } from "@bloomberg/media-ui-core";
import { useFortress } from "@foundation/fortress";
import styles from "./summary.module.css";
import { QuoteContext } from "~context/QuoteContext";
import SnapshotOverview from "~components/SnapshotOverview";
import KeyStatistics from "~components/KeyStatistics";
import { showKeyStastistic, showOverview } from "~utils";
import { getFortressState } from "~utils/getFortressState";
import { SnapshotCharts } from "~components/dynamic";

export default function SummaryContainer() {
  const quoteData = useContext(QuoteContext);
  const fortressContext = useFortress();
  const { isAllowed } = getFortressState(fortressContext);

  if (!quoteData) {
    return null;
  }
  const displayKeyStatistic = showKeyStastistic(quoteData);
  const displayOverview = showOverview(quoteData);

  return (
    <div className={classes([!isAllowed && styles.contentBlur])}>
      <SnapshotCharts />
      {isAllowed && (
        <>
          {displayOverview && <SnapshotOverview quoteData={quoteData} />}
          {displayKeyStatistic && <KeyStatistics quoteData={quoteData} />}
        </>
      )}
    </div>
  );
}
